import React from 'react';
import {View, Image, Dimensions, StyleSheet, AsyncStorage, Text} from 'react-native-web';
import {connect} from 'react-redux';
import sha256 from 'crypto-js/sha256';
import { loginUserAsync } from '../redux/actions';
import {ButtonWithSpinner, ConditionalTextRender, InputTextImage, ButtonText, Spacing} from "../components";
import Colors from "../constants/Colors";
import {Input} from "../components/input/Input";
import {stringIsEmpty} from "../constants/StringChecker";

class LoginScreen extends React.Component {

    state = {
        userEmail: '',
        userPassword: '',
        isLoading: false,
        logoutUser: false,
        errorMessage: '',

        dimensions: null,
    };

    handleLoginSuccess = (authResponse) => {
        // if (authResponse.data.userData.firstAccess) {
        //     this.props.navigation.navigate("Perfil")
        // } else {
        //     this.props.navigation.navigate('Home');
        // }

        this.props.history.push('/home');
    }

    handleLoginError = (error) => {
        console.log('login error', error);
        if (error.message === undefined) {
            // Alert.alert('Falha no Login', 'Ocorreu um erro ao realizar o login. Verifique suas informações!' )
        } else {
            // Alert.alert('Erro', error.message )
        }
    }

    async handleLoginInput() {

        const { userEmail, userPassword } = this.state;

        if (stringIsEmpty(userEmail)) {
            return;
        }

        try {
            let result = await this.props.loginUserAsync(userEmail, userPassword);
            this.handleLoginSuccess(result);
        } catch (error) {
            this.handleLoginError(error);
        }
    }

    handleAutoLogin = async () => {
        try {
            let email = await AsyncStorage.getItem('user_email');
            let password = await AsyncStorage.getItem('user_password');

            if (stringIsEmpty(email)) return;

            this.setState({userEmail: email});

            try {
                let result = await this.props.loginUserAsync(email, password);
                this.handleLoginSuccess(result);
            } catch (error) {
                this.handleLoginError(error);
            }

        } catch (e) {
            console.log(e);
        }
    };

    handleResize = (dimensions) => {
        this.setState({ dimensions: dimensions });
    };

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.handleResize);
    }

    componentDidMount() {
        this.setState({
            dimensions: {
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        })

        Dimensions.addEventListener("change", this.handleResize)
    }

    render() {

        const height =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.height;
        const width =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.width;

        return (
            <View style={{
                width: width,
                height: height,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: Colors.backgroundColor
            }}>
                <Image
                    source={require('../img/logos/logoLogin.png')}
                    style={{
                        width: 300,
                        height: 300,
                    }}
                    resizeMode={'contain'}
                />

                <View style={{ marginTop: 20, marginBottom: 6 }}>
                    <Input
                        value={this.state.userEmail}
                        placeholder={'ID de usuário'}
                        placeholderTextColor="black"
                        onChangeText={(input) => { this.setState({ userEmail: input.trim() }) }}
                        containerStyle={{ margin: 20, marginBottom: 5 }}
                        inputStyle={{ fontSize: 18 }}
                        keyboardType={'email-address'}
                        autoCapitalize={'none'}
                    />

                    <Input
                        value={this.state.userPassword}
                        placeholder={'Senha'}
                        onChangeText={(input) => { this.setState({ userPassword: input }) }}
                        containerStyle={{ margin: 20, marginTop: 0 }}
                        inputStyle={{ fontSize: 18 }}
                        placeholderTextColor="black"
                        secureTextEntry
                        autoCapitalize={'none'}
                    />
                </View>

                <ConditionalTextRender
                    text={this.props.errorMessage}
                    textPropsStyle={{ color: 'red', textAlign: 'center' }}
                />

                <ButtonWithSpinner
                    isLoading={this.props.isFetching}
                    size={'large'}
                    text={'Login'}
                    textPropsStyle={{ fontWeight: 'bold' }}
                    onPress={() => this.handleLoginInput()}
                    containerPropsStyle={{
                        marginBottom: 20,
                        marginTop: 20,
                        borderRadius: 4,
                        height: 40,
                        width: 220,
                        alignSelf: 'center'
                    }}
                />

                <ButtonText onPress={() => console.log('go to forgot password')} >
                    <Text style={{ fontSize: 20 }}>
                        Esqueci minha senha
                    </Text>
                </ButtonText>

                <Spacing height={16} />

                <ButtonText onPress={() => this.props.history.push('/register')}>
                    <Text style={{ fontSize: 22, }}>
                        Novo por aqui? Cadastre-se
                    </Text>
                </ButtonText>


            </View>
        )
    }
}

const styles = StyleSheet.create({
    inputTextStyle: {
        height: 10,
        width: 10
    },
    inputTextImageContainer: {
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderRadius: 0,
        borderColor: Colors.borderColor,
        marginLeft: 10,
        marginRight: 10,
    },
    buttonTextStyle: {
		fontSize: 20,
		fontWeight: 'bold',
		color: Colors.inputFontColor,
		textAlign: 'center',
	},
});

const mapStateToProps = state => {
    return {
        isFetching: state.auth.isFetching,
        errorMessage: state.auth.errorMessage,
    }
};

export default connect(mapStateToProps, { loginUserAsync })(LoginScreen);
